import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";
import "./is2.scss";

export default () => {
  const data = useStaticQuery(graphql`
    query is2 {
      file(relativePath: { eq: "components/pages/index/is2/index1.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  return (
    <div className="is2">
      <div className="is2-title container">
        <p>
          Set up as Gujarat's finest IELTS Training Institute with dedicated,
          Student Centric faculty and adopting 21st Century training techniques
          imparting both Online/Offline Training.
        </p>
      </div>
      <div className="is2-img">
        <div className="img-cont container">
          <Img fluid={data.file.childImageSharp.fluid} />
        </div>
      </div>
    </div>
  );
};
